import { Box, Skeleton } from '@betty/moonlight';
import { memo } from 'react';

function WheelSpinsSkeleton() {
  return (
    <Box
      flexDirection="row"
      width="100%"
      height={400}
      paddingHorizontal="space-300"
    >
      <Skeleton width="100%" height="100%" />
    </Box>
  );
}

export default memo(WheelSpinsSkeleton);
